import { Button, Modal } from "@shapr3d/frontend-lib";

import { downloadPageUrl } from "../../../config";
import useNavigation from "../../../hooks/navigation";
import { useProject } from "../../../hooks/useProject";
import { useTracker } from "../../../hooks/useTracker";
import { ModalClosedAction, ModalShownAction } from "../../../lib/TrackingAdapter";
import { DeepLinkIntent } from "../../../types";

import style from "./PublishVersionModal.module.css";

const PUBLISH_VERSION_VIDEO_URL =
  "https://d29vl8nlkx98pf.cloudfront.net/Shapr3D_publish_current_version_apple.mp4";

interface PublishVersionModalProps {
  open: boolean;
  onClose: () => void;
}

export const PublishVersionModal = ({ open, onClose }: PublishVersionModalProps) => {
  const tracker = useTracker();
  const navigation = useNavigation();
  const { data: projectData, isLoading: isProjectLoading } = useProject();

  return (
    <Modal
      open={open}
      size="medium"
      isLoading={isProjectLoading}
      onOpen={() => {
        tracker.trackModalShown(ModalShownAction.PUBLISH_VERSION_MODAL);
      }}
      onClose={() => {
        tracker.trackModalClosed(ModalClosedAction.PUBLISH_VERSION_MODAL);
        onClose();
      }}
    >
      <div className={style.container}>
        <div className={style.videoContainer}>
          <video
            className={style.video}
            src={PUBLISH_VERSION_VIDEO_URL}
            muted
            autoPlay
            playsInline
            loop
          />
        </div>
        <div className={style.title}>Publish a version from the Shapr3D app</div>
        <div className={style.description}>
          A published version is a read-only snapshot of your model that you share for feedback. It
          opens in any browser, and anyone with access to the project can view it.
        </div>
        <div className={style.actions}>
          <Button
            onClick={() => {
              if (projectData) {
                navigation.goToShaprApp({
                  projectId: projectData.project.projectId,
                  teamId: projectData.teamId,
                  intent: DeepLinkIntent.PublishVersion,
                  autoOpen: false,
                });
              }
            }}
          >
            Launch Shapr3D
          </Button>
          <a
            href={downloadPageUrl}
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              if (projectData) {
                tracker.trackDeeplinkGoToDownload({ projectId: projectData.project.projectId });
              }
            }}
          >
            <Button variant="borderless">Download Shapr3D</Button>
          </a>
        </div>
      </div>
    </Modal>
  );
};
